module.exports = __webpack_public_path__ + "static/media/download.b88272d3.svg";